import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export class TrackingDealersListMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({
    config,
    fromPageTrackingJsonToTrackingDataValueObjectMapper,
    fromSearchJSONToFiltersTrackingMapper,
    fromCamelToSnakeCase,
    toQueryString
  }) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
    this._fromSearchJSONToFiltersTrackingMapper = fromSearchJSONToFiltersTrackingMapper
    this._fromCamelToSnakeCase = fromCamelToSnakeCase
    this._toQueryString = toQueryString
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Object} param.data.filters
   * @param {String} param.data.filters.order
   * @param {Number} param.data.pageNumber
   * @param {Number} param.data.searchResultsCount
   *
   */

  _getDefaultTrackingData() {
    return {}
  }

  _getResultsTrackingData({order, pageNumber, searchFilters, searchResultsCount}) {
    return {
      page_category_level2: this._parseQueryParams(this._mapFilters(searchFilters)),
      list_page_num: pageNumber,
      search_result_number: searchResultsCount,
      order
    }
  }

  _mapFilters = filters =>
    Object.keys(filters)
      .sort()
      .reduce(
        (newFilters, filter) => ({
          ...newFilters,
          [this._fromCamelToSnakeCase(filter)]: filters[filter]
        }),
        {}
      )

  _parseQueryParams = queryParams =>
    decodeURIComponent(this._toQueryString(queryParams, {arrayFormat: 'repeat', delimiter: ':'})).toLowerCase()

  map({page, culture, data}) {
    const {filters: {order} = {}, pageNumber, searchResultsCount, search} = data

    const {filters: searchFilters} = this._fromSearchJSONToFiltersTrackingMapper.map({search})

    const hasResults = Boolean(searchFilters && Object.keys(searchFilters).length)

    const trackingData = hasResults
      ? this._getResultsTrackingData({
          order,
          pageNumber,
          searchResultsCount,
          searchFilters
        })
      : this._getDefaultTrackingData()

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page: hasResults ? `${page}_RESULTS` : page,
        culture
      })
      .map(trackingData)
  }
}
